/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S6_Li2_AfterInputs */

const tr_onbilgi_s6_li2_after = /** @type {(inputs: Onbilgi_S6_Li2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` sayfasından veya e-postadaki bağlantıdan yeni dönem için ödeme yapar; ödeme alındığında erişim kaldığı yerden devam eder.`)
};

const en_onbilgi_s6_li2_after = /** @type {(inputs: Onbilgi_S6_Li2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` page or via the link in the email; once payment is received, access continues where it left off.`)
};

const de_onbilgi_s6_li2_after = /** @type {(inputs: Onbilgi_S6_Li2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` oder über den Link in der E-Mail; nach Zahlungseingang geht der Zugang dort weiter, wo er stand.`)
};

const ru_onbilgi_s6_li2_after = /** @type {(inputs: Onbilgi_S6_Li2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` или по ссылке из письма; после поступления оплаты доступ продолжается с того же места.`)
};

/**
* | output |
* | --- |
* | "page or via the link in the email; once payment is received, access continues where it left off." |
*
* @param {Onbilgi_S6_Li2_AfterInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s6_li2_after = /** @type {((inputs?: Onbilgi_S6_Li2_AfterInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S6_Li2_AfterInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s6_li2_after(inputs)
	if (locale === "de") return de_onbilgi_s6_li2_after(inputs)
	if (locale === "ru") return ru_onbilgi_s6_li2_after(inputs)
	return tr_onbilgi_s6_li2_after(inputs)
});